import { FC, ReactNode, PropsWithChildren } from 'react';
import { Box, Card, Label, Typography } from '@oresundsbron/bridge-ui';

interface RecognitionCardProps {
  icon: ReactNode;
  statusIcon: ReactNode;
  label: string;
  value: string;
}

export const RecognitionCard: FC<PropsWithChildren<RecognitionCardProps>> = ({
  icon,
  statusIcon,
  label,
  value,
  children,
}) => (
  <Card.Root className="my-2 shadow-lg" rounded={false} shadow={false}>
    <Card.Content background="white">
      <Box className="flex items-center justify-between gap-4">
        <Box className="flex items-center gap-4">
          <Box>{icon}</Box>
          <Box className="relative">
            <Label rise as="p">
              {label}
            </Label>
            <Typography weight="medium">{value}</Typography>
          </Box>
        </Box>
        <Box>{statusIcon}</Box>
      </Box>
      {children}
    </Card.Content>
  </Card.Root>
);
